/**
 * The board look. Since the owner amendment of 2026-10-04 (`docs/DESIGN.md`,
 * "The board"; `docs/decisions/0056`) Interlock has one: Keyline, in a dark
 * and a light variant that follow the app's appearance. The six named themes
 * it replaced are gone, and so is choosing one.
 *
 * BASELINE 4 still holds, and this file is still where: a board look is
 * tokens and painters in this package, and the renderer only ever sees a
 * `Theme`. Changing the look (or adding a variant) touches nothing outside
 * `packages/themes`.
 */
import { keylineDark, keylineLight, type BoardBase } from './keyline.js';
import type { Theme, ThemeId } from './types.js';

/** The variants, in order: dark first, as the app's default appearance. */
export const BOARD_BASES: readonly BoardBase[] = ['dark', 'light'];

/** Every variant by id. */
export const THEMES: Readonly<Record<ThemeId, Theme>> = {
  'keyline-dark': keylineDark,
  'keyline-light': keylineLight,
};

/** The board for an appearance: a dark board on Dark, a light one on Light. */
export function boardTheme(base: BoardBase): Theme {
  return base === 'light' ? keylineLight : keylineDark;
}

/** The board a player who has chosen nothing sees: the dark one, as the app opens dark. */
export const defaultTheme: Theme = keylineDark;
